module.exports = new __parcel__URL__("no-search-results.6374065e.svg").toString();